import { render, staticRenderFns } from "./CustomerBasicInfo.vue?vue&type=template&id=4aab4425&"
import script from "./CustomerBasicInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports